export class UserRoleModel {
  public userRoleCode: string;
  public description: string;
  public status: string;
  public userRoleCategory: string;
  public userRoleCategoryCode: string;
  public user: string;
  public url:string;


  constructor(userRoleCode: string, description: string, status: string, userRoleCategory: string, userRoleCategoryCode: string ,user: string,url: string) {
    this.userRoleCode = userRoleCode;
    this.description = description;
    this.status = status;
    this.userRoleCategory = userRoleCategory;
    this.userRoleCategoryCode = userRoleCategoryCode;
    this.user = user;
    this.url = url;
  }
}
